import React, { useEffect, useRef, useMemo, useState } from 'react';
import { useHitTracking } from '../../context/hit-tracking-context';
import TradingViewWidget from '../../components/tradingView/tradingViewWidget';
import { Col, Container, Row } from 'react-bootstrap';
import { Sidebar } from 'primereact/sidebar';
import './technicalAnalysis.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faChartSimple, faTrash } from '@fortawesome/pro-solid-svg-icons';
import Streaming from '../../services/_realtime/price/Streaming';
import BlinkerBar from '../../components/blinker';
import Search from '../../components/search/search';
import ListBar from '../watchlist/components/listBar/listbarWatchlist';
import { Toast } from 'primereact/toast';
import { DashboardServiceApi } from '../../services/watchlist/api';
import { Configuration } from '../../services/watchlist/configuration';
import { ConfirmDialog } from 'primereact/confirmdialog';
import SearchTW from '../../components/search/search-tw';
import { APIControl } from '../../helpers/APIControl';
import { useTranslation } from 'react-i18next';
import { setUpdatedList } from '../../stores/watchlistTableSearchItemSlice';
import { useDispatch } from 'react-redux';
import Spinner from '../../components/spinner';

const TechnicalAnalysis = () => {
    const { t } = useTranslation();
    const { trackInteraction } = useHitTracking();
    const token = localStorage.getItem('token');
    const divRef = useRef(null);
    const [isLoading, setIsLoading] = useState(true);

    const watchlistApi = new DashboardServiceApi(
        new Configuration({
            basePath: process.env.REACT_APP_WATCHLIST_API_BASE_PATH,
        }),
        undefined,
        APIControl(process.env.REACT_APP_WATCHLIST_API_BASE_PATH)
    );
    // Parse selectedSecurity object from localStorage for default symbol
    const selectedSecurityRaw = localStorage.getItem('selectedSecurity');
    const selectedSecurityObj = selectedSecurityRaw ? JSON.parse(selectedSecurityRaw) : null;
    const defaultSymbolId = selectedSecurityObj?.id || selectedSecurityObj?.objectId || 'sec.101.411';
    const dispatch = useDispatch();

    const defaultSEcurityList = [
        {
            UniqueCode: 'USD_TRL:FX',
            Code: 'USD/TRY',
            Name: 'ABD DOLARI (TRL)',
            Flag: '1f23f9c36c2582f8acd9747c9fef592b',
            ObjectId: 'sec.39941.175',
            lastPrice: '',
            dailyChange: '',
        },
        {
            UniqueCode: 'EUR_TRL:FX',
            Code: 'EUR/TRY',
            Name: 'EURO (TRL)',
            Flag: 'aa5371abf080047bbfa810ba61b8f26f',
            ObjectId: 'sec.39941.349',
            lastPrice: '',
            dailyChange: '',
        },
        {
            UniqueCode: 'EUR_USD:FX',
            Code: 'EUR/USD',
            Name: 'EURO (USD)',
            Flag: '1f23f9c36c2582f8acd9747c9fef592b',
            ObjectId: 'sec.39941.350',
            lastPrice: '',
            dailyChange: '',
        },
        {
            UniqueCode: 'XU030:IS',
            Code: 'XU030',
            Name: 'BIST 30',
            Source: 'Borsa İstanbul',
            Flag: 'TR',
            ObjectId: 'sec.101.409',
            lastPrice: '',
            dailyChange: '',
        },
        {
            UniqueCode: 'XU100:IS',
            Code: 'XU100',
            Name: 'BIST 100',
            Source: 'Borsa İstanbul',
            Flag: 'TR',
            ObjectId: 'sec.101.411',
            lastPrice: '',
            dailyChange: '',
        },
        {
            UniqueCode: 'XAU/USD:USC',
            Code: 'XAU/USD',
            Name: 'GOLD',
            Flag: 'US',
            ObjectId: 'sec.47001.256',
            lastPrice: '',
            dailyChange: '',
        },
    ];

    const defaultBistSecurityList = [
        { id: 1, Code: 'XUTUM', Name: 'BIST TÜM', lastPrice: '', dailyChange: '', ObjectId: 'sec.101.417' },
        { id: 2, Code: 'XU100', Name: 'BIST 100', lastPrice: '', dailyChange: '', ObjectId: 'sec.101.411' },
        { id: 4, Code: 'XU030', Name: 'BIST 30', lastPrice: '', dailyChange: '', ObjectId: 'sec.101.409' },
        { id: 5, Code: 'XLBNK', Name: 'BIST LİKİT BANKA', lastPrice: '', dailyChange: '', ObjectId: 'sec.101.29976' },
        { id: 7, Code: 'XTM25', Name: 'BIST TEMETTÜ 25', lastPrice: '', dailyChange: '', ObjectId: 'sec.101.53540' },
        { id: 8, Code: 'XSGRT', Name: 'BIST SİGORTA', lastPrice: '', dailyChange: '', ObjectId: 'sec.101.402' },
        { id: 9, Code: 'X10XB', Name: 'BIST BANKA DISI LIKIT 10', lastPrice: '', dailyChange: '', ObjectId: 'sec.101.29974' },
        { id: 10, Code: 'XTMTU', Name: 'BIST TEMETTÜ', lastPrice: '', dailyChange: '', ObjectId: 'sec.101.912' },
        { id: 11, Code: 'XK030', Name: 'BIST KATILIM 30', lastPrice: '', dailyChange: '', ObjectId: 'sec.101.38594' },
        { id: 12, Code: 'XHOLD', Name: 'BIST HOLDİNG VE YATIRIM', lastPrice: '', dailyChange: '', ObjectId: 'sec.101.394' },
        { id: 13, Code: 'XGMYO', Name: 'BIST GAYRİMENKUL Y.O.', lastPrice: '', dailyChange: '', ObjectId: 'sec.101.393' },
    ];

    const toast = useRef(null);
    const [tradingViewIndex, setTradingViewIndex] = useState(defaultSymbolId);
    const [tradingViewWidth, setTradingViewWidth] = useState('100%');
    const [visibleWatchlist, setVisibleWatchlist] = useState(false);
    const [visibleMarkets, setVisibleMarkets] = useState(false);
    const [visibleBistMarket, setVisibleBistMarket] = useState(false);
    const [bistMarketsColumnsData, setBistMarketsColumnsData] = useState([]);
    const [bistMarketsData, setBistMarketsData] = useState([]);
    const [marketsColumnsData, setMarketsColumnsData] = useState([]);
    const [marketsData, setMarketsData] = useState([]);
    const [watchlistColumnsData, setWatchlistColumnsData] = useState([]);
    const [watchlistData, setWatchlistData] = useState([]);
    const [marketItems, setMarketItems] = useState(defaultSEcurityList);
    const [marketColumnItems, setMarketColumnItems] = useState([
        { id: 1, field: 'Code', displayName: t('tableHeader.securityCode'), header: t('tableHeader.securityCode'), isVisible: true, width: '34%', align: 'left' },
        { id: 2, field: 'lastPrice', displayName: t('tableHeader.lastPrice'), header: t('tableHeader.lastPrice'), template: '', isVisible: true, width: '33%', align: 'center' },
        { id: 3, field: 'dailyChange', displayName: t('tableHeader.change'), header: t('tableHeader.change'), isVisible: true, width: '33%', align: 'center' },
    ]);
    const [watchlistColumnItems, setWatchlistColumnItems] = useState([
        { id: 1, field: 'Code', displayName: t('tableHeader.securityName'), header: t('tableHeader.securityName'), isVisible: true, width: '34%', align: 'left' },
        { id: 2, field: 'lastPrice', displayName: t('tableHeader.buyingPrice'), header: t('tableHeader.buyingPrice'), template: '', isVisible: true, width: '33%', align: 'center' },
        { id: 3, field: 'dailyChange', displayName: t('tableHeader.sellPrice'), header: t('tableHeader.sellPrice'), isVisible: true, width: '33%', align: 'center' },
        { id: 4, field: 'dailyChange', displayName: t('tableHeader.lastPrice'), header: t('tableHeader.lastPrice'), isVisible: true, width: '33%', align: 'center' },
    ]);
    const [bistMarketItems, setBistMarketItems] = useState(defaultBistSecurityList);
    const [watchlistTableData, setWatchlistTableData] = useState([]);
    const [bistMarketColumnItems, setBistMarketColumnItems] = useState([
        { id: 1, field: 'Code', displayName: t('tableHeader.securityCode'), header: t('tableHeader.securityCode'), isVisible: true, width: '34%', align: 'left' },
        { id: 2, field: 'lastPrice', displayName: t('tableHeader.lastPrice'), header: t('tableHeader.lastPrice'), template: '', isVisible: true, width: '33%', align: 'center' },
        { id: 3, field: 'dailyChange', displayName: t('tableHeader.change'), header: t('tableHeader.change'), isVisible: true, width: '33%', align: 'center' },
    ]);
    const streamingRef = useRef(null);
    const streamingUnSub = useRef(null);

    const streamingWatchlistRef = useRef(null);
    const streamingWatchlistUnSub = useRef(null);

    const [selectedListBarItemId, setSelectedListBarItemId] = useState('');
    const [selectedListBarItemName, setSelectedListBarItemName] = useState('');
    const [tableData, setTableData] = useState([]);
    const [isLoadingTable, setIsLoadingTable] = useState(true);
    const [symbolListData, setSymbolListData] = useState([]);
    const [visibleAlert, setVisibleAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [selectedRemoveItemData, setSelectedRemoveItemData] = useState([]);
    const [updateListBar, setUpdateListBarId] = useState('');
    const [searchRowMarginLeft, setSearchRowMarginLeft] = useState('0%');
    const [isFocused, setIsFocused] = useState(false);
    const [panelOpen, setPanelOpen] = useState(false);
    const [isSearchDisabled, setIsSearchDisabled] = useState(false);

    useMemo(() => {
        if (panelOpen) {

            if (!streamingRef.current) {
                // setIsLoading(true);

                streamingRef.current = new Streaming();
                let objectIds = defaultSEcurityList.map((it) => it.ObjectId);
                defaultBistSecurityList.map((it) => objectIds.push(it.ObjectId));

                streamingUnSub.current = streamingRef.current.subscribe(
                    { objectIds: objectIds },
                    (data) => {
                        processStreamingData(data);
                        processBistStreamingData(data);

                    }
                );
            }
        }

        return () => {
            if (streamingRef.current) {
                streamingUnSub.current.Dispose();
            }
        };
    }, [panelOpen]);

    useMemo(() => {
        if (!panelOpen) {
            streamingRef.current = null;
            streamingUnSub.current = null;
            return;
        }
        if (symbolListData.length === 0) return;
        let objectIds = [];
        setIsLoading(true);
        symbolListData.map((item) => objectIds.push(item.entityId));
        if (!streamingWatchlistRef.current) {
            streamingWatchlistRef.current = new Streaming();
            streamingWatchlistUnSub.current = streamingWatchlistRef.current.subscribe(
                { objectIds: objectIds },
                (data) => {
                    processWatchlistStreamingData(data);
                }
            );
        }

        return () => {
            if (streamingWatchlistRef.current) {
                streamingWatchlistUnSub.current.Dispose();
            }
        };
    }, [symbolListData, panelOpen]);

    useEffect(() => {
        if (!panelOpen) {
            streamingRef.current = null;
            streamingUnSub.current = null;
        }
    }, [panelOpen]);

    useEffect(() => {
        if (visibleWatchlist) {
            setVisibleMarkets(false);
            setVisibleBistMarket(false);
        } else if (visibleMarkets) {
            setVisibleWatchlist(false);
            setVisibleBistMarket(false);
        } else if (visibleBistMarket) {
            setVisibleWatchlist(false);
            setVisibleMarkets(false);
        }
    }, [visibleWatchlist, visibleMarkets, visibleBistMarket]);

    useEffect(() => {
        const handleResize = () => {
            if (visibleWatchlist || visibleMarkets || visibleBistMarket) {
                setTradingViewWidth(window.innerWidth <= 1400 ? '60%' : window.innerWidth < 2250 ? '70%' : '80%');
                setSearchRowMarginLeft('34%');
            } else {
                setTradingViewWidth(window.innerWidth <= 1400 ? '90%' : window.innerWidth < 2250 ? '95%' : '100%');
                setSearchRowMarginLeft('5%');
            }
        };

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [visibleWatchlist, visibleMarkets, visibleBistMarket]);

    useEffect(() => {
        const searchElement = document.querySelector('.search-container-classname'); // Adjust the selector to match your actual search component class or ID

        if (searchElement) {
            if (selectedListBarItemId.includes('xu030') || selectedListBarItemId.includes('xu100')) {
                searchElement.style.opacity = 0;
                setIsSearchDisabled(true);


            } else {
                searchElement.style.opacity = 1;
                setIsSearchDisabled(false);

            }
        }
    }, [selectedListBarItemId]);


    const clickIndex = (item) => {
        setTradingViewIndex(item.ObjectId);
    };

    const clickWatchlistItem = (item) => {
        setTradingViewIndex(item['@']);
    };

    const clickPanelButton = (panelName) => {
        trackInteraction(`panel/${panelName}`);
        setPanelOpen(true);

        setVisibleWatchlist(false);
        setVisibleMarkets(false);
        setVisibleBistMarket(false);

        if (panelName === 'watchlist') {
            setVisibleWatchlist(true);
        } else if (panelName === 'markets') {
            setVisibleMarkets(true);
        } else if (panelName === 'bistMarket') {
            setVisibleBistMarket(true);
        }
    };

    const visiblePanel = (panelName) => {
        setPanelOpen(false);

        if (panelName === 'watchlist') {
            setVisibleWatchlist(false);
        } else if (panelName === 'markets') {
            setVisibleMarkets(false);
        } else if (panelName === 'bistMarket') {
            setVisibleBistMarket(false);
        }
    };

    const removeSymbolOnWatchlist = (data) => {
        try {
            setVisibleAlert(true);
            setAlertMessage("'" + data.symbolName + "' '" + selectedListBarItemName + "' İsimli listeden silmek istediğinize emin misiniz?");
            setSelectedRemoveItemData(data);
        } catch (error) {
            console.error('removeSymbolOnWatchlist error:', error);
        }
    };

    const removeSymbolReject = () => {
        try {
            setVisibleAlert(false);
        } catch (error) {
            console.error('removeSymbolReject error:', error);
        }
    };

    const selectedSearchItem = (item) => {
        try {
            console.log('props.selectedSearchItem:', item.document);
            setTradingViewIndex(item.document.objectId);
            addSymbol(item.document.objectId, item.document.name);
        } catch (error) {
            console.error('props.selectedSearchItem:', error);
        }
    };

    const selectedPageSearchItem = (item) => {
        try {
            console.log('props.selectedPageSearchItem:', item.document);
            setTradingViewIndex(item.document.objectId);
        } catch (error) {
            console.error('props.selectedPageSearchItem:', error);
        }
    };

    const selectedListBarItem = (id, name) => {
        try {
            

            if (updateListBar !== '') {
                id = updateListBar;
                setSelectedListBarItemId(id);
                setSelectedListBarItemName(name);
                setWatchlistTableData([]);
                setIsLoadingTable(true);
                getSymbolList(id);
                streamingWatchlistUnSub.current.Dispose();
                streamingRef.current = null;
                setUpdateListBarId('');
            } else {
                if (id) {
                    setSelectedListBarItemId(id);
                    setSelectedListBarItemName(name);
                    setWatchlistTableData([]);
                    setIsLoadingTable(true);
                    getSymbolList(id);
                    streamingWatchlistUnSub.current.Dispose();
                    streamingRef.current = null;
                }
            }
            // xu030
        } catch (error) {
            console.error('selectedListBarItem error:', error);
        }
    };
    const twoDecimalCodes = ['USD/TRY', 'EUR/TRY', 'EUR/USD'];
    const resolveWatchlistSymbolName = (entityId, fallback) => {
        const hit = symbolListData.find((item) => item.entityId === entityId);
        return (hit && hit.name) || fallback || '';
    };
    const processStreamingData = (msg) => {
        const cmd = msg['@'];
        if (!cmd || cmd === 'heartbeat') return;

        setMarketItems((prev) => {
            return prev.map((item) => {
                if (item.ObjectId === msg['@']) {
                    const pricePrecision = twoDecimalCodes.includes(item.Code) ? 4 : 2;
                    const newLastPrice = 'lastPrice' in msg ? parseFloat(msg.lastPrice).toFixed(pricePrecision) : item.lastPrice;
                    const newDailyChange = 'dailyChange' in msg ? parseFloat(msg.dailyChange).toFixed(2) : item.dailyChange;

                    const prevLastPrice = item.lastPrice;
                    const isIncreased = newLastPrice > prevLastPrice;
                    const isDecreased = newLastPrice < prevLastPrice;

                    return {
                        ...item,
                        lastPrice: newLastPrice,
                        dailyChange: newDailyChange,
                        blink: isIncreased ? 'blinkGreen' : isDecreased ? 'blinkRed' : '',
                    };
                }
                // setTimeout(() => {
                //     setIsLoading(false);
                // }, 1000);
                return item;
            });

        });
    };

    const processBistStreamingData = (msg) => {
        const cmd = msg['@'];
        if (!cmd || cmd === 'heartbeat') return;

        setBistMarketItems((prev) => {
            return prev.map((item) => {
                if (item.ObjectId === msg['@']) {
                    const newLastPrice = 'lastPrice' in msg ? parseFloat(msg.lastPrice).toFixed(2) : item.lastPrice;
                    const newDailyChange = 'dailyChange' in msg ? parseFloat(msg.dailyChange).toFixed(2) : item.dailyChange;

                    const prevLastPrice = item.lastPrice;
                    const isIncreased = newLastPrice > prevLastPrice;
                    const isDecreased = newLastPrice < prevLastPrice;

                    return {
                        ...item,
                        lastPrice: newLastPrice,
                        dailyChange: newDailyChange,
                        blink: isIncreased ? 'blinkGreen' : isDecreased ? 'blinkRed' : '',
                    };
                }
                return item;
            });
        });
    };

    const processWatchlistStreamingData = (msg) => {
        const cmd = msg['@'];
        if (!cmd || cmd === 'heartbeat' || cmd === 'handshake') return;
        const symbolName = msg.symbolName || resolveWatchlistSymbolName(msg['@'], msg.uniqueCode);

        setWatchlistTableData((prevData) => {
            const existingObjectIndex = prevData.findIndex((obj) => obj['@'] === msg['@']);
            if (existingObjectIndex !== -1) {
                return prevData.map((item) => {
                    if (item['@'] === msg['@']) {
                        if (msg.lastPrice) {
                            const prevLastPrice = item.lastPrice;
                            const newLastPrice = parseFloat(msg.lastPrice.toFixed(2));
                            const isIncreased = newLastPrice > prevLastPrice;
                            const isDecreased = newLastPrice < prevLastPrice;

                            item = {
                                ...item,
                                lastPrice: newLastPrice,
                                blink: isIncreased ? 'blinkGreen' : isDecreased ? 'blinkRed' : '',
                            };
                        }

                        if (msg.ask) {
                            const newAsk = parseFloat(msg.ask.toFixed(2));
                            const prevAsk = item.ask;
                            const isIncreasedAsk = newAsk > prevAsk;
                            const isDecreasedAsk = newAsk < prevAsk;

                            item = {
                                ...item,
                                ask: msg.ask,
                                blinkAsk: isIncreasedAsk ? 'blinkGreen' : isDecreasedAsk ? 'blinkRed' : '',
                            };
                        }

                        if (msg.bid) {
                            const newBid = parseFloat(msg.bid.toFixed(2));
                            const prevBid = item.bid;
                            const isIncreasedBid = newBid > prevBid;
                            const isDecreasedBid = newBid < prevBid;

                            item = {
                                ...item,
                                bid: msg.bid,
                                blinkBid: isIncreasedBid ? 'blinkGreen' : isDecreasedBid ? 'blinkRed' : '',
                            };
                        }

                        if (msg.symbolName) {
                            item = {
                                ...item,
                                symbolName: msg.symbolName,
                            };
                        } else if (symbolName && symbolName !== item.symbolName) {
                            item = {
                                ...item,
                                symbolName: symbolName,
                            };
                        }
                    }
                    setTimeout(() => {
                        setIsLoading(false);
                    }, 1000);
                    return item;
                });
            } else {
                const newLastPrice = msg.lastPrice ? parseFloat(msg.lastPrice.toFixed(2)) : '';
                const newAsk = msg.ask ? parseFloat(msg.ask.toFixed(2)) : '';
                const newBid = msg.bid ? parseFloat(msg.bid.toFixed(2)) : '';

                const prevLastPrice = '';
                const isIncreased = newLastPrice > prevLastPrice;
                const isDecreased = newLastPrice < prevLastPrice;

                const prevAsk = '';
                const isIncreasedAsk = newAsk > prevAsk;
                const isDecreasedAsk = newAsk < prevAsk;

                const prevBid = '';
                const isIncreasedBid = newBid > prevBid;
                const isDecreasedBid = newBid < prevBid;

                const newItem = {
                    '@': msg['@'],
                    lastPrice: newLastPrice,
                    blink: isIncreased ? 'blinkGreen' : isDecreased ? 'blinkRed' : '',
                    symbolName: symbolName,
                    ask: newAsk,
                    blinkAsk: isIncreasedAsk ? 'blinkGreen' : isDecreasedAsk ? 'blinkRed' : '',
                    bid: newBid,
                    blinkBid: isIncreasedBid ? 'blinkGreen' : isDecreasedBid ? 'blinkRed' : '',
                };
                setTimeout(() => {
                    setIsLoading(false);
                }, 1000);

                return [...prevData, newItem];
            }
        });
    };

    const getSymbolList = (listId) => {
        setSymbolListData([]);
        const culture = 'tr-TR';

        watchlistApi
            .watchlistSymbolListGet(token, listId, culture)
            .then((res) => {
                if (!res.data.error) {
                    streamingWatchlistRef.current = null;
                    streamingWatchlistUnSub.current = null;
                    setSymbolListData(res.data.symbols);
                } else {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Hata',
                        detail: res.data.error,
                        life: 3000,
                    });
                }
            })
            .catch((err) => {
                console.error(err);
            });
    };

    const removeSymbol = () => {
        try {
            const entityId = selectedRemoveItemData['@'];

            watchlistApi
                .watchlistRemoveSymbolGet(token, selectedListBarItemId, entityId)
                .then((res) => {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Başarılı',
                        detail: 'Sembol başarıyla silindi',
                        life: 3000,
                    });
                    const itemIndex = watchlistTableData.findIndex((item) => item['@'] === entityId);
                    const symbolListDataIndex = symbolListData.findIndex((item) => item.entityId === entityId);

                    if (symbolListDataIndex !== -1) {
                        symbolListData.splice(symbolListDataIndex, 1);
                        setSymbolListData([...symbolListData]);
                    }

                    if (itemIndex !== -1) {
                        watchlistTableData.splice(itemIndex, 1);
                        setWatchlistTableData([...watchlistTableData]);
                    }

                    setTimeout(() => {
                        setUpdateListBarId(selectedListBarItemId);
                    }, 500);
                })
                .catch((err) => {
                    console.error(err);
                });
            setVisibleAlert(false);
        } catch (error) {
            console.error('removeSymbol error:', error);
        }
    };

    const addSymbol = async (entityId, symbolName) => {
        watchlistApi
            .watchlistAddSymbolGet(token, selectedListBarItemId, entityId)
            .then((res) => {
                if (!res.data.error) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Başarılı',
                        detail: "'" + symbolName + "' izleme listesine eklendi.",
                        life: 3000,
                    });

                    setUpdateListBarId(selectedListBarItemId);
                    dispatch(setUpdatedList({ selectedListBarItem: selectedListBarItem, updatedList: res.data.watchlistSymbols }));
                } else {
                    if (res.data.error.includes('already exists')) {
                        toast.current.show({
                            severity: 'error',
                            summary: 'Hata',
                            detail: "'" + symbolName + "' izleme listesinde zaten mevcut.",
                            life: 3000,
                        });
                    } else {
                        toast.current.show({
                            severity: 'error',
                            summary: 'Bir hata oluştu (addSymbolToWatchlist) : ' + res.data.error,
                            detail: res.data.error.message,
                            life: 3000,
                        });
                    }
                }
            })
            .catch((err) => {
                console.error(err);
            });
    };

    return (
        <div className="technical-analysis-screen">
            <Toast ref={toast} position="bottom-right" />

            <ConfirmDialog
                visible={visibleAlert}
                onHide={() => setVisibleAlert(false)}
                message={alertMessage}
                header="Uyarı"
                icon="pi pi-exclamation-triangle"
                accept={removeSymbol}
                reject={removeSymbolReject}
                acceptLabel="Evet"
                rejectLabel="İptal"
            />

            <div data-testid="sidebar-buttons" className="panel" style={{ position: 'absolute', left: 0, zIndex: 999999 }}>
                <Sidebar
                    header={t('technicalAnalysis.sideMenu.markets')}
                    visible={visibleMarkets}
                    onHide={() => visiblePanel('markets')}
                    style={{ marginLeft: '100px', zIndex: 2 }}
                >
                    <Container className="m-t-20">
                        <Row>
                            {marketColumnItems.map((item) => (
                                <Col key={'marketColumnItems' + item.id} md="4" className="list-header roboto-medium-14" style={{ textAlign: item.align }}>
                                    {item.header}
                                </Col>
                            ))}
                        </Row>
                        <Row>
                            <Col md="12">
                                <hr className="list-hr" />
                            </Col>
                        </Row>
                        {marketItems.map((item) => (
                            <Row key={'marketItems' + item.ObjectId} onClick={() => clickIndex(item)} className="list-item-row">
                                <Col md="4" className="list-item roboto-regular-14">
                                    {item.Code}
                                    <span className="list-item-index-name roboto-regular-12">{item.Name}</span>
                                </Col>
                                <Col md="4" className={`stream-val-item list-item roboto-regular-14 text-align-center ${item.blink}`}>
                                    {item.lastPrice}
                                </Col>
                                <Col md="4" className="stream-val-item list-item roboto-regular-14 text-align-center">
                                    {item.dailyChange} %
                                </Col>
                            </Row>
                        ))}
                    </Container>
                </Sidebar>

                <Sidebar
                    header={t('technicalAnalysis.sideMenu.bistMarket')}
                    visible={visibleBistMarket}
                    onHide={() => visiblePanel('bistMarket')}
                    style={{ marginLeft: '100px', zIndex: 2 }}
                >
                    <Container className="m-t-20">
                        <Row>
                            {bistMarketColumnItems.map((item) => (
                                <Col key={'bistMarketColumnItems' + item.id} md="4" className="list-header roboto-medium-14" style={{ textAlign: item.align }}>
                                    {item.header}
                                </Col>
                            ))}
                        </Row>
                        <Row>
                            <Col md="12">
                                <hr className="list-hr" />
                            </Col>
                        </Row>
                        {bistMarketItems.map((item) => (
                            <Row key={'bistMarketItems' + item.ObjectId} onClick={() => clickIndex(item)} className="list-item-row">
                                <Col md="4" className="list-item roboto-regular-14">
                                    {item.Code}
                                    <span className="list-item-index-name roboto-regular-12">{item.Name}</span>
                                </Col>
                                <Col md="4" className={`stream-val-item list-item roboto-regular-14 text-align-center ${item.blink}`}>
                                    {item.lastPrice}
                                </Col>
                                <Col md="4" className="stream-val-item list-item roboto-regular-14 text-align-center">
                                    {item.dailyChange} %
                                </Col>
                            </Row>
                        ))}
                    </Container>
                </Sidebar>

                <Sidebar
                    data-testid="watchlist-button"
                    className="watchlist-button"
                    header={t('technicalAnalysis.sideMenu.watchlist')}
                    visible={visibleWatchlist}
                    onHide={() => visiblePanel('watchlist')}
                    style={{ marginLeft: '100px', zIndex: 2 }}
                >
                    <Container className="m-t-0 p-0">
                        <Row>
                            <div className="m-b-25 d-flex flex-wrap technical-analysis-screen-watchlist-bar">
                                <ListBar selectedListBarItem={selectedListBarItem} updateListBar={updateListBar} />
                            </div>
                        </Row>

                        <Row>
                            <Col md="12" style={{ opacity: 1 }} className='search-container-classname'>
                                <Search selectedSearchItem={selectedSearchItem} disabled={isSearchDisabled} />
                            </Col>
                        </Row>

                        <Row className="m-t-20">
                            {isLoading ? (
                                <div style={{ height: '35vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <Spinner />  {/* Loading durumu varsa spinner gösterilir */}
                                </div>) : (
                                watchlistColumnItems.map((item) => (
                                    <Col key={'watchlistColumnItems' + item.id} md="3" className="list-header roboto-medium-14" style={{ textAlign: item.align }}>
                                        {item.header}
                                    </Col>
                                )))}

                            {/* {watchlistColumnItems.map((item) => (
                                <Col key={'watchlistColumnItems' + item.id} md="3" className="list-header roboto-medium-14" style={{ textAlign: item.align }}>
                                    {item.header}
                                </Col>
                            ))} */}
                        </Row>
                        <Row>
                            <Col md="12">
                                <hr className="list-hr" />
                            </Col>
                        </Row>

                        {watchlistTableData.length > 0 &&
                            watchlistTableData.map((item) => (
                                <Row
                                    key={'watchlistTableData' + item['@']}
                                    onClick={() => clickWatchlistItem(item)}
                                    className="list-item-row"
                                >
                                    <Col md="3" className={`symbol-name-text roboto-medium-14 color-text`}>
                                        {item.symbolName}
                                    </Col>
                                    <Col md="2" className={`stream-val-item list-item roboto-regular-14 text-align-center ${item.blinkAsk}`}>
                                        {item.ask}
                                    </Col>
                                    <Col md="2" className={`stream-val-item list-item roboto-regular-14 text-align-center ${item.blinkBid}`}>
                                        {item.bid}
                                    </Col>
                                    <Col md="3" className={`list-item-remove-value roboto-regular-14 text-align-center ${item.blink}`}>
                                        {selectedListBarItemId !== 'predefinedxu030.9hcV7qYc' && (
                                            <>
                                                <label className="last-value color-text">{item.lastPrice}</label>
                                                <span className="remove-icon roboto-regular-12">
                                                    <FontAwesomeIcon
                                                        className="icon"
                                                        icon={faTrash}
                                                        onClick={() => removeSymbolOnWatchlist(item)}
                                                    />
                                                </span>
                                            </>
                                        )}

                                        {selectedListBarItemId === 'predefinedxu030.9hcV7qYc' && (
                                            <label className="last-value-xu30 color-text">{item.lastPrice}</label>
                                        )}
                                    </Col>
                                </Row>
                            ))}
                    </Container>
                </Sidebar>

                <Container className="m-t-30">
                    <Row>
                        <Col className="panel-button-col text-align-center" onClick={() => clickPanelButton('watchlist')}>
                            <div className="panel-button">
                                <FontAwesomeIcon className="panel-button-icon" icon={faStar} />
                            </div>
                            <label className="panel-button-title roboto-medium-14 m-t-10 text-align-center">
                                {t('technicalAnalysis.sideMenu.watchlist')}
                            </label>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="panel-button-col text-align-center" onClick={() => clickPanelButton('markets')}>
                            <div className="panel-button">
                                <FontAwesomeIcon className="panel-button-icon" icon={faChartSimple} />
                            </div>
                            <label className="panel-button-title roboto-medium-14 m-t-10 text-align-center">
                                {t('technicalAnalysis.sideMenu.markets')}
                            </label>
                        </Col>
                    </Row>

                    <Row>
                        <Col className="panel-button-col" onClick={() => clickPanelButton('bistMarket')}>
                            <div className="panel-button">
                                <FontAwesomeIcon className="panel-button-icon" icon={faStar} />
                            </div>
                            <label className="panel-button-title roboto-medium-14 m-t-10 text-align-center">
                                {t('technicalAnalysis.sideMenu.bistMarket')}
                            </label>
                        </Col>
                    </Row>
                </Container>
            </div>

            <Container>
                <Row>
                    <Col>
                        <div data-testid="TradingViewWidget" className="focusableDiv">
                            <TradingViewWidget symbolCode={tradingViewIndex} width={tradingViewWidth} />
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default TechnicalAnalysis;
